import React from 'react';

class AxleGroupWeights extends React.Component {
	constructor(props) {
		super(props)
		this.truck = this.props.truck;
	}

	render() {
		let axleGroups = this.truck.calculateAxleGroups();
		console.log(axleGroups);
		// Axle Number(s) in Group
		let processedAxleGroups = [];
		for (let i = 0; i < axleGroups.startAxle.length; ++i) {
			processedAxleGroups[i] = (axleGroups.startAxle[i] + 1) + ' to ' + (axleGroups.endAxle[i] + 1);
		}

		// Legal Weight
		let legalWeights = Array(axleGroups.startAxle.length).fill(0);
		// for each axle group...
		for (let i = 0; i < axleGroups.startAxle.length; ++i) {
			// for each axle in the group...
			for (let j = axleGroups.startAxle[i]; j <= axleGroups.endAxle[i]; ++j) {
				if (this.truck.steerable[j] == 'Yes') {
					legalWeights[i] += (this.truck.tireRating[j] * this.truck.tireCount[j] * 2);
				} else {
					legalWeights[i] += (this.truck.tireRating[j] * this.truck.tireCount[j]);
				}
				
			}
		}
		console.log(legalWeights);


		// Processing the full table
		let processedTable = [];
		for (let i = 0; i < axleGroups.startAxle.length; ++i) {
			processedTable[i] = {
				axleGroupNumber: i+1,
				axleNumber: processedAxleGroups[i],
				legal9ton: legalWeights[i],
				legal10ton: legalWeights[i]
			};
		}

		return(
			<div className="section">
				<span>Axle Group Weights</span>
				<table>
					<thead>
						<tr>
							<th>Axle Group Number</th>
							<th>Axle Number(s) in Group</th>
							<th>Legal Weight (10 ton road)</th>
							<th>Legal Weight(9 ton road)</th>
						</tr>
					</thead>
					<tbody>
						{processedTable.map(function(value, index) {
							return(
								<tr key={index}>
									<td>{value.axleGroupNumber}</td>
									<td>{value.axleNumber}</td>
									<td>{value.legal9ton}</td>
									<td>{value.legal10ton}</td>
								</tr>	
							)
						})}
					</tbody>
				</table>
			</div>
			
		);
	}
}

export default AxleGroupWeights;


// WEBPACK FOOTER //
// ./src/Minnesota/MNOutput/AxleGroupWeights.js